(() => {
  const money = (cents) => {
    const amount = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(cents || 0) / 100);
    return `€${amount}`;
  };

  const capsuleCount = (title) => {
    const match = String(title || '').match(/(\d+)/);
    return match ? Number(match[1]) : null;
  };

  document.querySelectorAll('[data-dm-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-dm-carousel-track]');
    const dots = Array.from(carousel.querySelectorAll('[data-dm-carousel-dot]'));
    if (!track || !dots.length) return;

    const setCurrent = () => {
      const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', setCurrent, { passive: true });
    setCurrent();
  });

  const initHomeAccordion = (scope = document) => {
    scope.querySelectorAll('[data-dm-accordion-button]').forEach((button) => {
      if (button.dataset.dmReady === 'true') return;
      button.dataset.dmReady = 'true';
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.querySelector('.visually-hidden').textContent = expanded ? 'Apri risposta' : 'Chiudi risposta';
        if (panel) panel.hidden = expanded;
      });
    });
  };

  const initReviewTracks = (scope = document) => {
    scope.querySelectorAll('[data-dm-review-section]').forEach((section) => {
      const track = section.querySelector('[data-dm-review-track]');
      const previous = section.querySelector('[data-dm-review-prev]');
      const next = section.querySelector('[data-dm-review-next]');
      if (!track || track.dataset.dmReady === 'true') return;
      track.dataset.dmReady = 'true';
      const step = () => track.querySelector('[data-dm-review-card]')?.getBoundingClientRect().width || track.clientWidth;
      const move = (direction = 1) => {
        const distance = step() + 18;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - distance / 2;
        const atStart = track.scrollLeft <= distance / 2;
        if (direction > 0 && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && atStart) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));

      const autoplayEnabled = section.dataset.dmReviewAutoplay === 'true';
      const interval = Math.max(4000, Number(section.dataset.dmReviewInterval) || 6000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let timer;
      let restartTimer;
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (autoplayEnabled && !reduceMotion && track.scrollWidth > track.clientWidth) {
          timer = window.setInterval(() => move(1), interval);
        }
      };
      const restart = () => {
        window.clearTimeout(restartTimer);
        restartTimer = window.setTimeout(start, 1800);
      };

      track.addEventListener(
        'pointerdown',
        () => {
          stop();
          restart();
        },
        { passive: true }
      );
      window.addEventListener('pointerup', restart, { passive: true });
      window.addEventListener('pointercancel', restart, { passive: true });
      track.addEventListener('touchend', restart, { passive: true });
      window.addEventListener('resize', restart, { passive: true });
      window.addEventListener('pageshow', start, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });
      start();
      window.setTimeout(start, 1000);
    });
  };

  initHomeAccordion();
  initReviewTracks();

  document.querySelectorAll('[data-dm-mobile-menu]').forEach((menu) => {
    const toggle = menu.querySelector('[data-dm-mobile-menu-toggle]');
    const panel = menu.querySelector('.dm-mobile-menu__panel');
    const header = menu.closest('.dm-site-header');
    if (!toggle || !panel) return;
    const mobileMenuViewport = window.matchMedia('(max-width: 1199px)');
    const isMenuOpen = () => menu.dataset.open === 'true';
    const setMenuPosition = () => {
      if (!header) return;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      menu.style.setProperty('--dm-mobile-menu-top', `${bottom}px`);
    };
    const syncMenuState = () => {
      const open = isMenuOpen();
      setMenuPosition();
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Chiudi menu' : 'Apri menu');
      document.body.classList.toggle('dm-mobile-menu-is-open', open);
      if (!open) {
        menu.querySelectorAll('.dm-mobile-submenu[open]').forEach((submenu) => {
          submenu.open = false;
          submenu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
      }
    };
    const setMenuOpen = (open) => {
      const nextOpen = Boolean(open);
      const changed = isMenuOpen() !== nextOpen;
      menu.dataset.open = String(nextOpen);
      syncMenuState();
      if (changed) {
        menu.dispatchEvent(new CustomEvent('dm:mobile-menu-toggle', { detail: { open: nextOpen } }));
      }
    };
    const toggleMenu = () => {
      setMenuPosition();
      setMenuOpen(!isMenuOpen());
    };
    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleMenu();
    });
    window.addEventListener('resize', () => {
      if (!mobileMenuViewport.matches && isMenuOpen()) {
        setMenuOpen(false);
        return;
      }
      setMenuPosition();
    }, { passive: true });
    window.addEventListener('scroll', () => {
      if (isMenuOpen()) setMenuPosition();
    }, { passive: true });
    document.addEventListener('click', (event) => {
      if (!isMenuOpen() || menu.contains(event.target)) return;
      setMenuOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isMenuOpen()) {
        setMenuOpen(false);
        toggle.focus();
      }
    });
    menu.querySelectorAll('.dm-mobile-submenu').forEach((submenu) => {
      const summary = submenu.querySelector('summary');
      const syncSubmenuState = () => summary?.setAttribute('aria-expanded', String(submenu.open));
      const setSubmenuOpen = (open) => {
        submenu.open = open;
        syncSubmenuState();
      };
      let directSubmenuToggleHandledAt = 0;
      const toggleSubmenu = () => setSubmenuOpen(!submenu.open);
      const handleDirectSubmenuToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        directSubmenuToggleHandledAt = Date.now();
        toggleSubmenu();
      };

      submenu.addEventListener('toggle', syncSubmenuState);
      if ('PointerEvent' in window) {
        summary?.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
          handleDirectSubmenuToggle(event);
        }, { passive: false });
      } else {
        summary?.addEventListener('touchend', handleDirectSubmenuToggle, { passive: false });
      }
      summary?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (Date.now() - directSubmenuToggleHandledAt < 700) return;
        toggleSubmenu();
      });
      syncSubmenuState();
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { setMenuOpen(false); }));
    menu.dataset.open = 'false';
    syncMenuState();
  });

  const productHeader = document.querySelector('.dm-site-header');
  const productHeaderSection = productHeader?.closest('.shopify-section-group-header-group.section-header');
  const productMobileMenu = productHeader?.querySelector('[data-dm-mobile-menu]');
  const pageTemplate = document.querySelector('main[data-template]')?.dataset.template;
  if (productHeaderSection && pageTemplate === 'product') {
    const phoneViewport = window.matchMedia('(max-width: 749px)');
    const headerSpacer = document.createElement('div');
    headerSpacer.className = 'dm-product-header-spacer';
    headerSpacer.hidden = true;
    headerSpacer.setAttribute('aria-hidden', 'true');
    productHeaderSection.after(headerSpacer);

    let framePending = false;

    const showProductHeader = () => {
      productHeaderSection.classList.remove('dm-product-header--hidden');
    };

    const resetProductHeader = () => {
      productHeaderSection.classList.remove(
        'dm-product-header--fixed',
        'dm-product-header--hidden',
        'dm-product-header--sticky-mobile'
      );
      headerSpacer.hidden = true;
      headerSpacer.style.height = '';
    };

    const updateProductHeader = () => {
      framePending = false;
      const currentScrollY = Math.max(window.scrollY, 0);

      if (!phoneViewport.matches) {
        resetProductHeader();
        return;
      }

      productHeaderSection.classList.add('dm-product-header--sticky-mobile');

      if (currentScrollY <= 2) {
        productHeaderSection.classList.remove('dm-product-header--fixed');
        showProductHeader();
        headerSpacer.hidden = true;
        headerSpacer.style.height = '';
        return;
      }

      headerSpacer.style.height = `${productHeaderSection.offsetHeight}px`;
      headerSpacer.hidden = false;
      productHeaderSection.classList.add('dm-product-header--fixed');
      showProductHeader();
    };

    const scheduleProductHeaderUpdate = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateProductHeader);
    };

    window.addEventListener('scroll', scheduleProductHeaderUpdate, { passive: true });
    window.addEventListener('resize', scheduleProductHeaderUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleProductHeaderUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleProductHeaderUpdate, { passive: true });
    window.addEventListener('load', scheduleProductHeaderUpdate, { passive: true });
    productMobileMenu?.addEventListener('dm:mobile-menu-toggle', (event) => {
      if (event.detail?.open) showProductHeader();
      scheduleProductHeaderUpdate();
    });
    productHeaderSection.addEventListener('focusin', showProductHeader);
    scheduleProductHeaderUpdate();
    window.setTimeout(scheduleProductHeaderUpdate, 500);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dm-cookie-preferences]');
    if (!button) return;

    const policyFallback = () => window.location.assign('/pages/cookie-policy#gestisci-preferenze');
    const openPreferences = () => {
      const privacyBanner = window.privacyBanner || window.Shopify?.privacyBanner;
      if (typeof privacyBanner?.showPreferences === 'function') {
        Promise.resolve(privacyBanner.showPreferences()).catch(policyFallback);
        return true;
      }

      const privacyApi = window.Shopify?.customerPrivacy;
      if (typeof privacyApi?.showPreferences === 'function') {
        Promise.resolve(privacyApi.showPreferences()).catch(policyFallback);
        return true;
      }

      const nativeButton = document.querySelector(
        '[data-shopify-cookie-preferences], #shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs'
      );
      if (nativeButton && nativeButton !== button) {
        nativeButton.click();
        return true;
      }

      return false;
    };

    if (openPreferences()) return;

    const handlePrivacyReady = () => {
      if (!openPreferences()) policyFallback();
    };
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', handlePrivacyReady, { once: true });
    window.setTimeout(() => {
      document.removeEventListener('shopifyCustomerPrivacyApiLoaded', handlePrivacyReady);
      if (!openPreferences()) policyFallback();
    }, 800);
  });

  const mobileCta = document.querySelector('[data-dm-mobile-cta]');
  const hero = document.querySelector('.dm-hero');
  const footer = document.querySelector('.dm-home-footer');
  if (mobileCta && hero) {
    const updateMobileCta = () => {
      const heroPassed = hero.getBoundingClientRect().bottom < 0;
      const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
      mobileCta.classList.toggle('is-visible', heroPassed && !footerVisible);
    };
    window.addEventListener('scroll', updateMobileCta, { passive: true });
    window.addEventListener('resize', updateMobileCta, { passive: true });
    updateMobileCta();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHomeAccordion(event.target);
    initReviewTracks(event.target);
  });

  document.querySelectorAll('[data-dm-product]').forEach((scope) => {
    const variantInput = scope.querySelector('[name="id"]');
    const prices = Array.from(scope.querySelectorAll('[data-dm-price]'));
    const sticky = document.querySelector('[data-dm-sticky-atc]');
    const stickyPrice = sticky?.querySelector('[data-dm-sticky-price]');
    const stickyVariant = sticky?.querySelector('[data-dm-sticky-variant]');
    const stickyButton = sticky?.querySelector('[data-dm-sticky-submit]');
    const mainButton = scope.querySelector('[data-dm-submit]');
    const summarySaving = scope.querySelector('[data-dm-summary-saving]');
    const variants = Array.from(scope.querySelectorAll('[data-dm-variant]'));

    const base = variants
      .map((variant) => ({
        capsules: capsuleCount(variant.dataset.variantTitle),
        price: Number(variant.dataset.variantPrice),
      }))
      .filter((variant) => variant.capsules && variant.price)
      .sort((a, b) => a.capsules - b.capsules)[0];

    const updateVariant = (variant) => {
      if (!variant || !variant.checked || variant.disabled) return;
      variantInput.value = variant.value;
      prices.forEach((price) => { price.textContent = money(variant.dataset.variantPrice); });
      const comparePrice = Number(variant.dataset.comparePrice);
      const variantPrice = Number(variant.dataset.variantPrice);
      if (summarySaving && comparePrice > variantPrice) {
        summarySaving.textContent = `Risparmia ${money(comparePrice - variantPrice)}`;
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.dataset.variantPrice);
      if (stickyVariant) stickyVariant.textContent = variant.dataset.variantTitle;
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', variant.value);
      history.replaceState(null, '', `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`);
    };

    variants.forEach((variant) => {
      const capsules = capsuleCount(variant.dataset.variantTitle);
      const saving = variant.querySelector('[data-dm-saving]');
      if (base && capsules && saving) {
        const basePerCapsule = base.price / base.capsules;
        const currentPerCapsule = Number(variant.dataset.variantPrice) / capsules;
        const saved = Math.max(0, Math.round((basePerCapsule - currentPerCapsule) * capsules));
        saving.textContent = saved > 0 ? `Risparmi ${money(saved)} rispetto al formato da ${base.capsules}` : 'Formato prova';
      }

      variant.addEventListener('change', () => {
        updateVariant(variant);
      });
    });

    updateVariant(variants.find((variant) => variant.checked && !variant.disabled));

    stickyButton?.addEventListener('click', () => mainButton?.click());

    if (sticky && mainButton) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0.2 }
      );
      observer.observe(mainButton);
    }
  });

  document.querySelectorAll('[data-dm-countdown]').forEach((timer) => {
    const hours = timer.querySelector('[data-dm-countdown-hours]');
    const minutes = timer.querySelector('[data-dm-countdown-minutes]');
    const seconds = timer.querySelector('[data-dm-countdown-seconds]');
    if (!hours || !minutes || !seconds) return;

    const pad = (value) => String(value).padStart(2, '0');
    const updateCountdown = () => {
      const now = new Date();
      const nextUpdate = new Date(now);
      nextUpdate.setHours(24, 0, 0, 0);
      const remaining = Math.max(0, nextUpdate.getTime() - now.getTime());
      const totalSeconds = Math.floor(remaining / 1000);
      hours.textContent = pad(Math.floor(totalSeconds / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    };

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });
})();
